export default __webpack_public_path__ + "images/dbadf705862c464202563442279b55bc.png";